import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { MaterialModule } from '../app.module';
import { ComponentsModule } from '../shared/components/components.module';

import { InvoicesRoutes } from './invoices.routing';
import { SharedModule } from '../shared/shared.module';
import { ModulosModule } from '../modulos/modulos.module';

import { InvoicesComponent } from './invoices.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { AddressesComponent } from './invoice/addresses/addresses.component';
import { ItemsComponent } from './invoice/items/items.component';
import { ShippingComponent, showShippingDetails, AddInfoToBox } from './invoice/shipping/shipping.component';
import { TaxesComponent } from './invoice/taxes/taxes.component';

@NgModule({
  declarations: [
    InvoicesComponent,
    InvoiceComponent,
    AddressesComponent,
    ItemsComponent,
    ShippingComponent,
    TaxesComponent,
    showShippingDetails,
    AddInfoToBox
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(InvoicesRoutes),
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule,
    SharedModule,
    ModulosModule
  ]
})
export class InvoicesModule { }
